<template>
      <div class="banner-info1">
        <div class="video">
          <div class="video-player">
            <!-- <video ref="videoPlayer" width="100%" controls @play="onPlay" controlslist="nodownload">
              <source :src="videoSource" type="video/mp4" />
              Your browser does not support the video tag.
            </video> -->
          </div>
          <!-- <div class="video-player-img" v-if="isVideoFailed">
              <img loading="lazy"  src="../../../static/img/home/videoFailed.png" alt="">
              <div class="video-failed-info">Loading failed, please try again later...</div>
          </div> -->
          <!-- @click="togglePlay" -->
          <div class="info" v-show="isShow" >
            <!-- <div class="title"><img loading="lazy"  src="../../static/img/productImg/video/china.png" alt=""></div> -->
            <div class="play">
              <img loading="lazy"  src="../../../static/img/product/play.png" alt="" v-if="false">
              <!-- <div class="desc">Watch the video</div> -->
            </div>
          </div>
        </div>
      </div>
</template>
<script>
// import travelVideo from '../../../static/video/travel.mp4'
export default {
  data() {
    return {
      // videoSource:travelVideo,
      isPlaying: false,
      volume: 1,
      isShow:true,
    };
  },
  methods: {
    // togglePlay() {
    //   const video = this.$refs.videoPlayer;
    //   if (this.isPlaying) {
    //     video.pause();

    //   } else {
    //     video.play();
    //     this.isShow = false;

    //   }
    //   this.isPlaying = !this.isPlaying;
    // },
    // onPlay(){
    //   this.isShow = false;
    // },
  }
};
</script>
<style scoped lang="scss">
@import '/style/phone/header/productContentBanner.scss';
.banner-info1 {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 0.625rem; 
    margin-top: 5.5rem;
    padding: 2.5rem 0;
  
    .video {
        width: 75rem; 
        height: 40.75rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .title {
        width: 21.875rem;
        height: 6.875rem;
        margin-bottom: 1.875rem;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .play {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.875rem;
        color: #FFF;
        img {
            display: block;
            width: 2.375rem; 
            height: 2.375rem; 
        }
    }
}
video{
  border-radius: 0.5rem;
}
.video-player {
  width: 100%;
  height: 100%;
}

.controls {
  margin-top: 0.625rem;
}
button {
  padding: 0.625rem;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}
button:hover {
  background-color: #0056b3;
}
input[type="range"] {
  margin: 0 0.625rem;
}
span {
  font-weight: bold;
}
.info{
  cursor: pointer;
  position: absolute;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: url('../../../static/img/videoBackground/img2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 108%;
  border-radius: 0.5rem;
}
</style>